"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreCategorySchema = void 0;
const zod_1 = require("zod");
const _1 = require(".");
const __1 = require("..");
exports.StoreCategorySchema = _1.ItemCategorySchema.and(zod_1.z.object({
    store: __1.StoreSchema.partial().required({ id: true }),
}));
//# sourceMappingURL=item-store-category.js.map